class PfCartDiscount extends HTMLElement {
  #controller = new AbortController();
  #discounts = [];

  connectedCallback() {
    const { signal } = this.#controller;

    this.applyBtn?.addEventListener("click", this.onDiscountApply.bind(this), { signal });

    this.querySelectorAll("[discount-remove-btn]").forEach(btn => {
      btn.addEventListener("click", this.onDiscountRemove.bind(this), { signal });
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get applyBtn() {
    return this.querySelector("[discount-apply-btn]");
  }

  get inputEl() {
    return this.querySelector("[discount-code-input]");
  }

  get checkoutBtn() {
    return document.querySelector(".checkout-btn");
  }

  get codesWrapper() {
    return this.querySelector(".pf-discount-codes");
  }

  get discounts() {
    return this.#discounts;
  }

  set discounts(val) {
    this.#discounts = val;
  }

  getCurrentDiscounts() {
    return Array.from(this.querySelectorAll("[discount-remove-btn]"))
      .map(btn => btn.dataset.code);
  }

  async updateCart() {
    this.toggleLoader();

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: this.discounts.join(",") })
    });

    const cart = await res.json();

    this.toggleLoader(false);

    buildCart(cart)
  }

  async onDiscountApply(e) {
    e.preventDefault();

    const code = this.inputEl.value.trim();
    if (!code) return;

    this.discounts = this.getCurrentDiscounts();

    if (!this.discounts.includes(code)) {
      this.discounts.push(code);
    }

    await this.updateCart();
    this.inputEl.value = "";
  }

  async onDiscountRemove(e) {
    const code = e.currentTarget.dataset.code;

    this.discounts = this.getCurrentDiscounts().filter(c => c !== code);

    await this.updateCart();
  }

  toggleLoader(loading = true) {
    this.applyBtn?.toggleAttribute("disabled", loading);
    this.inputEl?.toggleAttribute("disabled", loading);
    this.codesWrapper?.classList.toggle("pf-disabled", loading);
    this.checkoutBtn?.classList.toggle("pf-disabled", loading);
  }
}

if (!customElements.get("pf-cart-discount")) {
  customElements.define("pf-cart-discount", PfCartDiscount);
}


// PF CART UPSELL
class PfCartUpsell extends HTMLElement {
  #controller = new AbortController()

  connectedCallback() {
    this.renderRecommendations();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get recommendationsUrl() {
    return window.Shopify.routes.root + "recommendations/products?product_id=" + this.dataset.productId + "&limit=" + this.dataset.limit + "&section_id=pf-upsell-products&intent=" + this.dataset.intent;
  }

  get upsellWrapper() {
    return this.querySelector(".pf-upsell-wrapper");
  }

  async renderRecommendations() {
    if(!this.dataset.productId) return;

    const html = await this.fetchRecommendations();
    if(!html) return;

    const upsellProductsHtml = html.querySelector(".pf-upsell-products");
    if (!upsellProductsHtml) return;
    
    this.upsellWrapper.innerHTML = upsellProductsHtml.outerHTML;
  }

  async fetchRecommendations() {
    try {
      const res = await fetch(this.recommendationsUrl, {
        signal: this.#controller.signal,
      });
      const text = await res.text();

      const html = document.createElement("div");
      html.innerHTML = text;

      return html;
    } catch (error) {
      console.log("Error fetching recommendations", error);

      return null;
    }
  }
}

if(!customElements.get("pf-cart-upsell")) {
  customElements.define("pf-cart-upsell", PfCartUpsell);
}

// PF UPSELL SLIDER
class PfUpsellSlider extends HTMLElement {
  #controller = new AbortController();
  slider = null;

  connectedCallback() {
    const { signal } = this.#controller;

    this.initSlider();

    this.upsellCartButtons.forEach(button => {
      button.addEventListener("click", this.onUpsellATC.bind(this), { signal });
    })
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  get sliderEl() {
    return this.querySelector("[data-slider]");
  }

  get prevEl() {
    return this.querySelector(".pf-upsell-prev");
  }

  get nextEl() {
    return this.querySelector(".pf-upsell-next");
  }

  get upsellCartButtons() {
    return this.querySelectorAll(".pf-upsproduct-add");
  }

  initSlider() {
    this.slider = new Swiper(this.sliderEl, {
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        prevEl: this.prevEl,
        nextEl: this.nextEl
      }
    });
  }

  async onUpsellATC(e) {
    e.preventDefault();

    const form = e.target.closest(".pf-upsproduct-form");
    const selectEl = form?.querySelector(".pf-upsproduct-select");

    if(!selectEl) return;

    try {
      const formData = {
        items: [
          {
            id: selectEl.value,
            quantity: 1
          }
        ]
      }

      this.classList.add("pf-loading");

      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      });

      const cart = await res.json();

      this.classList.remove("pf-loading");

      buildCart(cart);
    } catch (error) {
      console.log("ATC Error", error);
    }
  }

  destroySlider() {
    if(this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }
}

if(!customElements.get("pf-upsell-slider")) {
  customElements.define("pf-upsell-slider", PfUpsellSlider);
}